import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFlag, FaRegStar, FaExchangeAlt } from "react-icons/fa";
import Layout from "../../Component/Layout"; // adjust path to match your project structure

const LocalizationTile = () => {
  const navigate = useNavigate();

  const tiles = [
    {
      name: "India",
      icon: <FaFlag />,
      path: "/finance/localization/india",
    },
    {
      name: "Exchange Rate",
      icon: <FaExchangeAlt />,
      path: "/cable/localization/exchange-rate",
    },
  ];

  return (
    <Layout>
      <style>{`
        .loc-wrapper {
          padding: 32px;
          font-family: Inter, Poppins, sans-serif;
        }

        .loc-header {
          margin-bottom: 28px;
        }

        .loc-header h1 {
          font-size: 26px;
          font-weight: 700;
          color: #0b1f4d;
          margin: 0 0 6px 0;
        }

        .loc-header p {
          font-size: 14px;
          color: #6b7280;
          margin: 0;
        }

        .loc-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
        }

        .loc-module-tile {
          width: 260px;
          background: #ffffff;
          border: 1px solid #edf0f5;
          border-radius: 16px;
          padding: 24px;
          cursor: pointer;
          box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
          transition: transform 0.15s ease, box-shadow 0.15s ease;
          position: relative;
        }

        .loc-module-tile:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(16, 24, 40, 0.10);
        }

        .loc-module-icon {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          background: #dbeafe;
          color: #2563eb;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          margin-bottom: 18px;
        }

        .loc-module-star {
          position: absolute;
          top: 22px;
          right: 22px;
          color: #d1d5db;
          font-size: 15px;
        }

        .loc-module-name {
          font-size: 17px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 6px;
        }

        .loc-module-link {
          font-size: 13px;
          color: #6b7280;
        }
      `}</style>

      <div className="loc-wrapper">
        <div className="loc-header">
          <h1>Localization</h1>
          <p>Manage country-specific and tax-specific configurations</p>
        </div>

        <div className="loc-grid">
          {tiles.map((tile) => (
            <div
              key={tile.name}
              className="loc-module-tile"
              onClick={() => navigate(tile.path)}
            >
              <FaRegStar className="loc-module-star" />
              <div className="loc-module-icon">{tile.icon}</div>
              <div className="loc-module-name">{tile.name}</div>
              <div className="loc-module-link">Open Module &rarr;</div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default LocalizationTile;